import React from "react";

export const Title = () => {
  return (
    <>
      <div className="main-head">Survey Tool</div>

    </>
  );
};
export default Title;